import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

interface ConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  open?: boolean;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const ConfirmModal: FC<ConfirmModalProps> = ({ open = false, onConfirm, onCancel }) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <Stack sx={style} spacing={4}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Are you sure?
        </Typography>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="contained" onClick={onConfirm}>
            Continue
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};
